import React, { useState } from 'react';
import { Redirect } from "react-router-dom"
import { Button, Typography, withStyles } from "@material-ui/core"
import { getLandingPath } from "../sc-utilities"

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        textAlign: 'center',
        marginTop: '10%'
    },
    button: {
        margin: theme.spacing(2)
    }
});



const PageNotFound = (props) => {
    const { classes } = props

    const [redirect, setRedirect] = useState(null)

    const handleRedirect = () => {
        // Not every role can open the asset overview; sending them there loops back to 404.
        setRedirect(getLandingPath())
    }

    if (redirect) return <Redirect to={redirect} />

    return <div className={classes.root}>
        <Typography color="primary" variant="h1">
            404
        </Typography>
        <Typography color="primary" variant="h3">
            Requested page was not found
        </Typography>
        <Button className={classes.button} variant={"outlined"} color={"primary"} onClick={handleRedirect}>Go to home</Button>
    </div>
}

export default withStyles(styles, { withTheme: true })(PageNotFound);